import { UnassignedOrderCounts } from '@services';
import { useStore } from '@stores';
import { useEffect } from 'react';

/**
 * The side panel's Jobs badge: one count per list (see UnassignedOrderScope), unfiltered. It says
 * how much work the garage still has waiting, not how much of it the panel is currently showing -
 * the Unscheduled | Unassigned badges inside the panel are the filtered ones. The caller adds up
 * the lists its view can actually reach: the week and month grids draw the dated jobs themselves,
 * so there the badge is the Unscheduled count alone.
 */
export const useUnAssignedCount = (): { counts: UnassignedOrderCounts } => {
  const { orderStore } = useStore();

  useEffect(() => {
    orderStore.getUnAssignedTotals();
  }, [orderStore]);

  return { counts: orderStore.unAssignedTotals };
};
